// config.json's `"mock": "auto"`: what this site's GET /healthz says decides between the real API and the demo.
// Only a clear "no Deleg8 here" (a static host: 404, or an answer that is not Deleg8's) means the demo. A slow, down
// or failing Deleg8 (timeout, network error, 5xx) is still the real one: the app shows its error, never invented
// tickets to a signed-in person (GAPS-DELEG8, 5 Oct 2026).
export type Health = { kind: 'answer'; status: number; body: unknown } | { kind: 'unreachable' };

export function demoFromHealth(h: Health): boolean {
  if (h.kind === 'unreachable') return false;
  if (h.status >= 500) return false;
  const b = h.body as { ok?: unknown; signIn?: unknown } | null;
  const isDeleg8 = !!b && typeof b === 'object' && b.ok === true && typeof b.signIn === 'object';
  return !isDeleg8;
}
